<template>
  <div class="chart-area">
    <highcharts class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
export default {
   computed: {
    chartData: function(){
      return this.chartLowData(); 
    }
  },
  data(){
    return {
    idcList: null,
    chartLowData : [
      [100],
      [200],
      [200],
      [200],
      [200],
      [200],
    ],
    chartOptions: {
      chart: {
        inverted: false,
        height: 260
      },

      accessibility: {
        description : null
      },

      title: {
          text: null
      },

      subtitle: {
          text: null
      },

      xAxis: {
        categories: [],
        labels: {
          style: {
            fontSize: '8.8px'
          }
        },
        //max: 17,

      },

      yAxis: {
        title: {
          text: null
        },
        labels: {
          style: {
            fontSize: '10px'
          }
        },
      },

      tooltip: {
        valueSuffix: '명'
      },



      plotOptions: {
          columnrange: {
              dataLabels: {
                  enabled: true,
                  format: '{y}명'
              }
          },
        series: {
          groupPadding: 0,
          pointPadding: 0.2,
          borderWidth: 0,
          dataLabels: {
            style: {
              fontSize: '10px',
              fontWeight: 'normal'
            }
          }
        }
      },

      legend: {
          enabled: false
      },

      series: [{
          //name: 'Temperatures',
          // /zoneAxis: 'y',

          data: [
            100,200,300,200,100,100
          ]
      }]
      },
    }
  },
  mounted(){

    this.loadlocation();
  },
  methods: {
    async loadlocation(){
      let location = await this.$store.getters['location/location'];
      this.idcList = location.filter(x => x.isDeleteYN == "N");
      this.loadChart();
    },
    loadChart(){
      var data = []
      this.chartOptions.xAxis.categories = this.idcList.map(x=>x.locationName)
      /*
      this.chartLowData.forEach(function(item){
        item[0]
        var o = {};
        o.low = item[0];
        o.high = item[1];
        o.color = '#117ce9';
        //zone으로 처리 불가하여 이렇게 처리
        if(o.high >= 24)
          o.color = '#ffb819';
        if(o.high >= 26)
          o.color = '#f84d3a';
        data.push(o);
      })
      */
      //this.chartOptions.series[0].data = data
      }
  }
}
</script>

<style>

</style>